import React from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FiChevronDown, FiChevronRight, FiPieChart } from 'react-icons/fi'
import {
  Label,
  MenuElement,
  MenuList,
} from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'

function Statistics({
  isSidebarOpen,
  className,
  size = 1,
}: IStatisticsProps & WithTranslation & IWithSize) {
  const [isOpen, toggleOpen] = React.useState(false)
  // const userId = useSelector(getUserId)

  function toggleIsOpen() {
    toggleOpen(!isOpen)
  }

  // const trackClick = () => {
  //   Mixpanel.people.increment(userId, 'Statistics Menu Opened', 1)
  //   Mixpanel.track('Statistics Menu Item Used', {})
  // }
  // const trackClick2 = () => {
  //   Mixpanel.people.increment(userId, 'Room Report Menu Opened', 1)
  //   Mixpanel.track('Main Menu Room Report Item Used', {})
  // }

  return (
    <MenuElement
      size={size}
      alignCenter={true}
      primary={true}
      column={true}
      open={isOpen}
      active={isOpen}
    >
      <MenuElement
        size={size}
        as={'div'}
        alignCenter={true}
        open={isOpen}
        onClick={toggleIsOpen}
        className={`${className}-button-expand`}
        nested={true}
      >
        <b>
          <FiPieChart size={16 * size} />
        </b>
        <Label primary={true} size={size} className={`${className}-label`}>
          <Trans i18nKey={'menu_statistics'}>Staytstyki</Trans>
        </Label>
        <b>
          {isSidebarOpen &&
            (isOpen ? (
              <FiChevronDown size={14 * size} />
            ) : (
              <FiChevronRight size={14 * size} />
            ))}
        </b>
      </MenuElement>
      {isSidebarOpen && (
        <MenuList size={size} nested={true}>
          {/*<Link*/}
          {/*  onClick={trackClick2}*/}
          {/*  size={size}*/}
          {/*  to={'/statistics/room'}*/}
          {/*  activeClassName={'active'}*/}
          {/*  nested={true}*/}
          {/*  className={`${className}-item-1-label`}*/}
          {/*>*/}
          {/*  <MenuElement*/}
          {/*    size={size}*/}
          {/*    alignCenter={true}*/}
          {/*    className={`${className}-item-1-button`}*/}
          {/*  >*/}
          {/*    <Trans i18nKey={'z4806_label'}>Raport pokoi</Trans>*/}
          {/*  </MenuElement>*/}
          {/*</Link>*/}
          {/*<Link*/}
          {/*  size={size}*/}
          {/*  to={'/statistics/reservations'}*/}
          {/*  activeClassName={'active'}*/}
          {/*  nested={true}*/}
          {/*  className={`${className}-item-2-label`}*/}
          {/*  onClick={trackClick}*/}
          {/*>*/}
          {/*  <MenuElement*/}
          {/*    size={size}*/}
          {/*    alignCenter={true}*/}
          {/*    className={`${className}-item-2-button`}*/}
          {/*  >*/}
          {/*    <Trans i18nKey={'menu_reservations'}>Rezerwacje</Trans>*/}
          {/*  </MenuElement>*/}
          {/*</Link>*/}
        </MenuList>
      )}
    </MenuElement>
  )
}

export default Statistics

export interface IStatisticsProps {
  isSidebarOpen: boolean
  className?: string
}
